/**
 * Admin Redux reducer — M5 Admin Console state.
 * Follows the identical pattern as subscriptionReducer.js.
 */

export const ADMIN_ACTION_TYPES = Object.freeze({
  SET_LOADING: 'admin/SET_LOADING',
  SET_ERROR: 'admin/SET_ERROR',
  SET_STATS: 'admin/SET_STATS',
  SET_USERS: 'admin/SET_USERS',
  UPDATE_USER: 'admin/UPDATE_USER',
  CLEAR: 'admin/CLEAR',
});

export const initialAdminState = Object.freeze({
  stats: null,
  users: [],
  total: 0,
  page: 1,
  totalPages: 1,
  loading: false,
  error: null,
});

export default function adminReducer(state = initialAdminState, action) {
  if (!action || typeof action !== 'object') return state;

  switch (action.type) {
    case ADMIN_ACTION_TYPES.SET_LOADING:
      return { ...state, loading: Boolean(action.payload), error: null };

    case ADMIN_ACTION_TYPES.SET_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload ? String(action.payload) : null,
      };

    case ADMIN_ACTION_TYPES.SET_STATS:
      return { ...state, stats: action.payload, loading: false, error: null };

    case ADMIN_ACTION_TYPES.SET_USERS:
      return {
        ...state,
        users: action.payload.users || [],
        total: action.payload.total || 0,
        page: action.payload.page || 1,
        totalPages: action.payload.totalPages || 1,
        loading: false,
        error: null,
      };

    case ADMIN_ACTION_TYPES.UPDATE_USER: {
      // Merge the updated user fields back into the list
      const updated = action.payload;
      return {
        ...state,
        users: state.users.map((u) =>
          u.id === updated.id ? { ...u, ...updated } : u
        ),
        loading: false,
        error: null,
      };
    }

    case ADMIN_ACTION_TYPES.CLEAR:
      return { ...initialAdminState };

    default:
      return state;
  }
}
